/**
 * Altura útil da tela quando o teclado está aberto.
 *
 * No iPhone, abrir o teclado NÃO muda a altura do layout: o Safari só encolhe a
 * "janela visual" e desliza a página por cima. Elemento com `position: fixed`
 * continua ancorado na altura antiga — é por isso que a caixa de escrever
 * some atrás do teclado e a tela parece deformada.
 *
 * A API `visualViewport` é a única que informa a altura de verdade. Publicamos
 * o valor numa variável CSS e o layout da conversa se apoia nela.
 *
 * Em navegador sem a API, a variável simplesmente não existe e o CSS usa a
 * altura normal — o comportamento de antes, nunca pior.
 */
export function acompanharTeclado(): () => void {
  const vv = window.visualViewport;
  if (!vv) return () => undefined;

  const aplicar = () => {
    // `offsetTop` entra na conta porque a página desliza para cima quando o
    // campo em foco fica perto do rodapé.
    const altura = Math.round(vv.height + vv.offsetTop);
    document.documentElement.style.setProperty('--altura-visivel', `${altura}px`);
    const teclado = Math.max(0, Math.round(window.innerHeight - altura));
    document.documentElement.style.setProperty('--teclado', `${teclado}px`);
    document.documentElement.classList.toggle('com-teclado', teclado > 120);
  };

  aplicar();
  vv.addEventListener('resize', aplicar);
  vv.addEventListener('scroll', aplicar);
  return () => {
    vv.removeEventListener('resize', aplicar);
    vv.removeEventListener('scroll', aplicar);
  };
}
